import BrandProduct from './BrandProduct';
export default BrandProduct;
